import React from "react";
import moment from "moment";
import { Drawer, Row, Col, Form, Input, Select, DatePicker, Button, Divider } from "antd";
import InputMask from "react-input-mask";
import { dateToBr } from "../../../../helpers/functions";
const Option = Select.Option;
const { MonthPicker } = DatePicker;
const InputGroup = Input.Group;
const baseNcmOptions = [
  { id: Math.random(), value: 1, text: "Monofásico" },
  { id: Math.random(), value: 5, text: "ST PIS/COFINS" },
  { id: Math.random(), value: 2, text: "Tributado" },
  {
    id: Math.random(),
    value: 3,
    text: "NCM possui códigos EX Monofásicos ou ST"
  },
  { id: Math.random(), value: 4, text: "NCM não encontrada" }
];

const currentOptions = [
  { id: Math.random(), value: 1, text: "Monofásico" },
  { id: Math.random(), value: 5, text: "ST PIS/COFINS" },
  { id: Math.random(), value: 2, text: "Tributado" }
];

const DrawerFilter = props => {
  const { sCodigoProduto, sDescricao, sNcm, sEx, sEan, sPeriodo } = props.filter;
  const { vazioEX } = props.dropdown;

  async function cleanFilters() {
    await props.handleReset();
    props.handleFilters();
  }

  return (
    <Drawer
      title='Filtrar produtos'
      className='ant-drawer--custom'
      width={600}
      onClose={() => props.onClose("visibleDrawerFilter")}
      visible={props.visibleDrawer}
    >
      <Form layout='vertical' hideRequiredMark>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label='Descrição'>
              <Input
                className='form-control'
                name='Descricao'
                value={sDescricao && sDescricao.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={() => {
                  props.handleFilters();
                  props.onClose("visibleDrawerFilter");
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='Código do Item'>
              <Input
                className='form-control'
                name='CodigoProduto'
                value={sCodigoProduto && sCodigoProduto.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={() => {
                  props.handleFilters();
                  props.onClose("visibleDrawerFilter");
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label='NCM'>
              <InputMask
                className='form-control'
                name='Ncm'
                value={sNcm ? sNcm.substr(1) : ""}
                mask={"9999.99.99"}
                onChange={props.handleChangeField}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='EX'>
              <InputGroup compact>
                <Select value={(vazioEX ? "Vazio" : "Selecionar")} style={{ width: '107px' }} onChange={props.handleDropdownEX}>
                  <Option value="Selecionar">Selecionar</Option>
                  <Option value="Vazio">Vazio</Option>
                </Select>
                <Input
                  className='form-control'
                  name='Ex'
                  disabled={vazioEX}
                  style={{ width: '160px', height: '33px' }}
                  value={sEx && sEx.substr(1)}
                  onChange={props.handleChangeField}
                  onPressEnter={() => {
                    props.handleFilters();
                    props.onClose("visibleDrawerFilter");
                  }}
                />
              </InputGroup>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label='EAN'>
              <Input
                className='form-control'
                name='Ean'
                value={sEan && sEan.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={() => {
                  props.handleFilters();
                  props.onClose("visibleDrawerFilter");
                }}              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          {!sPeriodo ? (
            <Col span={12}>
              <Form.Item label='e-Consulta'>
                <Select
                  className='ant-select--custom'
                  defaultValue={props.selectedBaseNcm}
                  value={props.selectedBaseNcm}
                  onChange={e => props.handleChangeField(e, "BaseNcm")}
                >
                  <Option value={null}>Todos</Option>
                  {baseNcmOptions.map(item => {
                    return (
                      <Option key={item.id} value={item.value}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
        </Row>

        <Divider className='mt-0' />

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='Período'>
              <MonthPicker
                className='ant-calendar--custom'
                name='Periodo'
                value={sPeriodo ? moment(dateToBr(sPeriodo.substr(1)), "MM/YYYY") : null}
                format='MM/YYYY'
                onChange={(e, val) => props.handleChangeField("Periodo", val)}
              />
            </Form.Item>
          </Col>
          {sPeriodo ? (
            <Col span={12}>
              <Form.Item label='Tributação Considerada'>
                <Select
                  className='ant-select--custom'
                  defaultValue={props.selectedCurrent}
                  value={props.selectedCurrent}
                  onChange={e => props.handleChangeField(e, "BaseClassificacaoUsuario")}
                >
                  <Option value={null}>Todos</Option>
                  {currentOptions.map(item => {
                    return (
                      <Option key={item.id} value={item.value}>
                        {item.text}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          ) : null}
        </Row>
      </Form>

      <div className='ant-drawer__footer'>
        <Button className='mr-3' onClick={() => cleanFilters()}>
          Limpar
        </Button>

        <Button
          onClick={() => {
            props.handleFilters();
            props.onClose("visibleDrawerFilter");
          }}
          type='primary'
        >
          Filtrar
        </Button>
      </div>
    </Drawer>
  );
};

export default DrawerFilter;
